import { BaseFieldClass } from './baseField.class'

import { IImageListField, IImageValue } from '@/types/serverField.type'

export class ImageListFieldClass extends BaseFieldClass {
  declare fieldValue: IImageValue[] | File[] | null
  declare initialValue: IImageValue[] | null

  constructor (field: IImageListField) {
    super(field)

    const value = field.Value ?? field.DefaultValue
    this.initialValue = this.prepareValue(value as IImageValue[] | null)
    this.fieldValue = this.prepareValue(value as IImageValue[] | null)
  }

  prepareValue (value: IImageValue[] | null): IImageValue[] | null {
    return value
  }

  getValue () {
    return {
      [this.name]: this.fieldValue
    }
  }

  appendToFormData (_formData: FormData): void {
    if (!this.fieldValue) return

    this.fieldValue.forEach((item, index) => {
      // Если это новый загруженный файл - просто добавляем его в форму
      if (item instanceof File) {
        _formData.append(`${this.name}__${index}`, item)
        return
      }

      let value: string | File = ''
      const isDeleted = !(item instanceof File) && item.Deleted === true

      if (isDeleted) {
        // Если файл удален - передадим его uuid и флаг удаления
        value = JSON.stringify({
          Uuid: item.Uuid,
          Delete: true
        })
      } else {
        // Последний возможный вариант (IImageValue)
        // конвертируем в строку
        value = JSON.stringify(item)
      }

      _formData.append(`${this.name}__${index}`, value)
    })
  }

  getFilterValue (): null {
    return null
  }
}
